import { h } from 'preact';
import { useEffect, useState } from 'preact/hooks';
import { ON_SERVER, PRERENDERED_DATA } from '../../consts.js';

const LOADED_CACHE = {};

function shouldStartAsLoaded(path) {
  if (ON_SERVER) {
    return true;
  }

  if (path in LOADED_CACHE) {
    return true;
  }

  if (PRERENDERED_DATA && PRERENDERED_DATA.ll_preloaded === path) {
    return true;
  }

  return false;
}

export default function BrowserLazyLoader(props) {
  const { LL_Fallback, LL_Component, path, ...componentProps } = props;
  const renderProps = { path, ...componentProps };

  function Wrapper() {
    const [hasLoaded, setHasLoaded] = useState(shouldStartAsLoaded(path));

    function loader() {
      if (hasLoaded) {
        return;
      }

      function onLoadReady() {
        LOADED_CACHE[path] = true;
        setHasLoaded(true);
      }

      LL_Component.preload(onLoadReady);
    }

    useEffect(loader, [hasLoaded, path, LL_Component]);

    if (hasLoaded) {
      return h(LL_Component, renderProps);
    } else {
      return h(LL_Fallback, renderProps);
    }
  }

  return <Wrapper />;
}
